module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai668-84ed7fccdb519ac72cb09b739810e8ed.jpg";